<template>
  <v-container 
    v-if="!$apollo.loading"
    fill-height
    fluid
    grid-list-xl
  >
    <helper-add-phone
      v-if="phoneDialog"
      :show-dialog="phoneDialog"
      @closePhoneDialog="closePhoneDialog"
    />
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        v-if="!_.isEmpty(userProjects)"
        md12
      >
        <h2>{{ $t('projects.myProjects') }}</h2>
        <v-btn
          class="primary btn-project"
          @click="addProject()"
        >
          {{ $t('projects.newProject') }}
        </v-btn>
        <v-card>
          <v-data-table
            class="text-no-wrap" 
            :headers="headers"
            :items="userProjects"
            :hide-default-footer="true"
            :mobile-breakpoint="900"
            :items-per-page="200"
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                v-text="header.text"
              />
            </template>
            <template v-slot:item.logo="{ item }">
              <v-avatar
                :tile="false"
                :size="40"
              >
                <v-img
                  :src="(item.logo || require('@/images/no-image.png'))"
                  :lazy-src="item.logo"
                  max-height="40"
                  contain
                />
              </v-avatar>  
            </template>
            <template v-slot:item.ticker="{ item }">
              <a
                v-if="item.ranking != null"
                @click.prevent="$router.push(`/ranking/${item.ranking.id}`)"
              ><b class="ticker">{{ item.ticker }}</b></a>
              <b
                v-if="item.ranking == null"
                class="ticker"
              >{{ item.ticker }}</b>
              <br><small class="name">{{ item.name }}</small>
            </template>
            <template v-slot:item.created_at="{ item }">
              {{ item.created_at | moment("L") }}
            </template>
            <template v-slot:item.status="{ item }">
              <b 
                :class="item.status == 'active' ? 'text-positive' : ''"
              >
                {{ $t('globals.'+item.status) }} 
              </b>
            </template>
            <template v-slot:item.strategytype="{ item }">
              <small>{{ $t('projects.'+item.strategytype) }}</small>
            </template>
            <template v-slot:item.base_curency="{ item }">
              {{ item.base_currency }}
            </template>
            <template v-slot:item.actions="{ item }">
              <v-menu
                offset-y
                left
                bottom
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="mr-2"
                    outlined 
                    small
                    text
                    v-on="on"
                  >
                    {{ $t('projects.manageButton') }}
                  </v-btn>
                </template>
                <v-sheet dense>
                  <v-list-item
                    @click="editProject(item)"
                  >
                    <v-list-item-title>{{ $t('globals.editButton') }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click="confirmDeleteProject(item)"
                  >
                    <v-list-item-title>{{ $t('projects.deleteButton') }}</v-list-item-title>
                  </v-list-item>
                </v-sheet>
              </v-menu>
              <v-btn
                v-if="item.status == 'pending'"
                outlined
                text
                small
                :disabled="loading"
                :loading="loading"
                @click="openDialog(item)"
              >
                {{ $t('projects.incubateButton') }}
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
      <v-flex
        v-else
        md5
        xs12
        new-record
      >
        <v-row>
          <v-col cols="12">
            <v-row
              justify="center"
              align="center"
            >
              <v-col>
                <v-card
                  style="padding:50px"
                >
                  <component :is="newIcon" />
                  <h3>{{ $t('projects.myProjects') }}</h3>
                  <p>
                    {{ $t('projects.notFoundMessage1') }}
                    <b><a
                      href="https://www.bitmex.com/register"
                      target="_blank"
                    >Bitmex</a></b> 
                    {{ $t('accounts.or') }}
                    <b><a
                      href="https://accounts.binance.com/en/register"
                      target="_blank"
                    >Binance</a></b> 
                    {{ $t('projects.notFoundMessage2') }}
                  </p>  
                  <v-btn
                    class="primary"
                    @click="addProject()"
                  >
                    {{ $t('projects.newProject') }}
                  </v-btn>
                </v-card> 
              </v-col>
            </v-row>  
          </v-col>
        </v-row>    
      </v-flex>
      <v-dialog
        v-model="dialog"
        persistent
        width="500"
      >
        <v-card>
          <v-card-title
            class="header info"
            primary-title
          >
            <b>{{ $t('projects.testPeriod') }}</b>
          </v-card-title>

          <v-card-text class="mt-5">
            <p v-if="selectedItem && selectedItem.view_permission == 'public'">
              {{ $t('projects.testCond') }}
              <a
                :href="$i18n.locale == 'ru' ? 'https://aivia.io/blog/ru/kriterii-otbora-treiderov-dlya-kopi-treidinga/' :'https://aivia.io/blog/en/criteria-for-traders-and-bots/'" 
                target="_blank"
              ><b>{{ $t('projects.followLink') }}</b>
              </a>
            </p>
            <p v-if="selectedItem && selectedItem.view_permission == 'link'">
              {{ $t('projects.viaLinkInfo') }}
            </p>
            <v-flex xs12>
              <v-list-item style="padding-left:0; margin-bottom:10px;">
                <v-list-item-action>
                  <v-switch
                    v-model="importSwitch"
                    color="indigo darken-2"
                  />
                </v-list-item-action>
                <v-list-item-title>
                  {{ $t('projects.importHistory') }}
                </v-list-item-title>
              </v-list-item>
              <v-menu
                v-if="importSwitch"
                v-model="datePicker"
                :close-on-content-click="false"
                :nudge-right="120"
                top
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="formatedImportFromDate"
                    :label="$t('globals.from')"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-date-picker 
                  v-model="importFromDate" 
                  :locale="$i18n.locale"
                  :min="$moment().subtract(3, 'years').format('YYYY-MM-DD')"
                  :max="$moment().format('YYYY-MM-DD')"
                  @input="datePicker = false"
                />
              </v-menu>
            </v-flex>
          </v-card-text>

          <v-divider />

          <v-card-actions>
            <v-spacer />
            <v-btn
              text
              :disabled="loading"
              @click="dialog = false"
            >
              {{ $t('globals.cancelButton') }}
            </v-btn>
            <v-btn
              color="primary"
              :disabled="loading"
              :loading="loading"
              @click="startIncubation()"
            >
              {{ $t('projects.incubateButton') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <helper-confirm-dialog
        v-if="confirmDialog"
        :show-dialog="confirmDialog"
        :text="$t('projects.reallyDelete', {ticker: selectedProject.ticker})"
        @closeConfirmDialog="closeConfirmDialog"
      />
    </v-layout>
  </v-container>
</template>

<script>

import USER_PROJECTS_QUERY from '@/graphql/queries/UserProjects.gql'
import DELETE_PROJECT_MUTATION  from '@/graphql/mutations/DeleteProject.gql'

import IconPoject from '@/components/icons/IconProject.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'UserProjects',
  data() {
    return {
      newIcon: IconPoject,
      datePicker: null,
      confirmDialog: false,
      phoneDialog: false,
      selectedProject: null,
      dialog: false,
      loading: false,
      params: {},
      importFromDate: this.$moment().subtract(6, 'months').format('YYYY-MM-DD'),
      importSwitch: true,
      selectedItem: null,
      userProjects: [],
      headers: [
        {
          sortable: false,
          text: '',
          value: 'logo'
        },
        {
          sortable: false,
          text: this.$t('globals.ticker'),
          value: 'ticker'
        },
        {
          sortable: false,
          text: this.$t('globals.trading'),
          value: 'strategytype'
        },
        {
          sortable: false,
          text: this.$t('globals.status'),
          value: 'status',
        },
        {
          sortable: false,
          text: this.$t('projects.baseCurrency'),
          value: 'base_currency',
        },
        {
          sortable: false,
          text: this.$t('projects.createdAt'),
          value: 'created_at',
        },
        {
          sortable: false,
          text: '',
          value: 'actions',
        },
      ]
    } 
  },
  computed: {
     ...mapGetters('user', ['getUser']),
     formatedImportFromDate() {
       return this.$moment(this.importFromDate).format('ll');
     }
  },
  methods: {
    addProject() {
      if (this.getUser.obfuscated_phone == null) {
        this.phoneDialog = true;
        return;
      } 
      this.$router.push('project/create')
    },
    editProject (item) {
      this.selectedProject = item
      if (this.getUser.obfuscated_phone == null) {
        this.phoneDialog = true;
        return;
      } 
      this.$router.push({ 
          name: 'Edit Project', 
          params: { id: item.id },
      })
    },
    confirmDeleteProject(item) {
      this.confirmDialog = true
      this.selectedProject = item
    },
    closeConfirmDialog(confirmed) {
      this.confirmDialog = false
      if (confirmed) {
        this.deleteProject()
      }
    },
    deleteProject() {
      this.$apollo
      .mutate({
        mutation: DELETE_PROJECT_MUTATION,
        variables: {
          id: this.selectedProject.id,
        }
      })
      .then(data => {
        this.$store.commit('app/setNotifier', this.$t('globals.success'));
        this.$apollo.queries.userProjects.refetch()
      })
      .catch(error => {
        this.errorHandler(error);
        this.loading = false;
      });
    },
    startIncubation() {
      this.dialog = false
      this.loading = true
      this.params.id = this.selectedItem.id
      if (this.importSwitch) {
        this.params.import_from_date = this.importFromDate + ' 00:00:00'
      }
      this.$apollo.mutate({
          mutation: require('@/graphql/mutations/IncubateProject.gql'),
          variables: this.params,
          update: (store, data) => {
            data = data.data.incubateProject
            const cache = store.readQuery({ query: USER_PROJECTS_QUERY })
            cache.userProjects.forEach((element, index) => {
              if (element.id == this.selectedItem.id) {
                element.incubate_till = data.till;
                element.status = data.status;
                element.ranking = {
                  id: data.ranking_id
                }
              }
            });
          },       
        }).then(data => {
            this.loading = false
            this.$store.commit('app/setNotifier', this.$t('globals.success'));
        }).catch(error => {
            if (_.isArray(error.graphQLErrors)) {
                this.$store.commit('app/setNotifier', error.graphQLErrors[0].message);
            }
            this.loading = false;  
        })
    },
    openDialog(item) {
      this.dialog = true;
      this.selectedItem = item;
    },
    closePhoneDialog(val) {
      this.phoneDialog = val;
      if (this.getUser.obfuscated_phone == null) return;
      if (this.selectedProject != null) {
        this.editProject(this.selectedProject.id)
        return;
      }
      this.addProject()
    }
  },
  apollo: {
    userProjects: {
      query: USER_PROJECTS_QUERY,
    }
  }
}
</script>
<style lang="scss" scoped>
  h2 {
    display: inline-block;
  }
  .btn-project {
    float: right;
    margin: 20px 0 10px;
  }
  .ticker {
    font-weight: 700;
    color: #9c27b0;
  }
  .name {
    font-weight: 600;
    color: #7f97ab;
  }
  .v-avatar {
    margin: 10px 0;
  }
</style>
